"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataVendorInProcessReasonCodeToDescription = exports.DataVendorInProcessReasonCode = exports.DataVendorReferToRepReasonCode = exports.dataVendorCancelledReasonCodeToDescription = exports.DataVendorCancelledReasonCode = void 0;
var DataVendorCancelledReasonCode;
(function (DataVendorCancelledReasonCode) {
    DataVendorCancelledReasonCode["PROGRAMS"] = "PROGRAMS";
    DataVendorCancelledReasonCode["PRODUCT"] = "PRODUCT";
    DataVendorCancelledReasonCode["PRODUCTHG"] = "PRODUCTHG";
    DataVendorCancelledReasonCode["PRODUCTNG"] = "PRODUCTNG";
    DataVendorCancelledReasonCode["PRODUCTFL"] = "PRODUCTFL";
    DataVendorCancelledReasonCode["PRODUCTOTH"] = "PRODUCTOTH";
    DataVendorCancelledReasonCode["PRODUCTBI"] = "PRODUCTBI";
    DataVendorCancelledReasonCode["SOFTWARE"] = "SOFTWARE";
    DataVendorCancelledReasonCode["PRIVACY"] = "PRIVACY";
    DataVendorCancelledReasonCode["DATA"] = "DATA";
    DataVendorCancelledReasonCode["PSDI"] = "PSDI";
    DataVendorCancelledReasonCode["O"] = "O";
    DataVendorCancelledReasonCode["EE"] = "EE";
    DataVendorCancelledReasonCode["MAIL"] = "MAIL";
    DataVendorCancelledReasonCode["SHAREDB"] = "SHAREDB";
    DataVendorCancelledReasonCode["INTEREST"] = "INTEREST";
    DataVendorCancelledReasonCode["CCP_ISSUE"] = "CCP_ISSUE";
    DataVendorCancelledReasonCode["INACTIVE"] = "INACTIVE";
    DataVendorCancelledReasonCode["CLINICCLSD"] = "CLINICCLSD";
    DataVendorCancelledReasonCode["CLINICSOLD"] = "CLINICSOLD";
    DataVendorCancelledReasonCode["NORESPONSE"] = "NORESPONSE";
})(DataVendorCancelledReasonCode = exports.DataVendorCancelledReasonCode || (exports.DataVendorCancelledReasonCode = {}));
exports.dataVendorCancelledReasonCodeToDescription = {
    [DataVendorCancelledReasonCode.PROGRAMS]: 'Dissatisfied with CC+ Program',
    [DataVendorCancelledReasonCode.PRODUCT]: 'Does Not Promote/sell product (legacy value)',
    [DataVendorCancelledReasonCode.PRODUCTHG]: 'Does Not Promote/sell HeartGard',
    [DataVendorCancelledReasonCode.PRODUCTNG]: 'Does Not Promote/sell NexGard',
    [DataVendorCancelledReasonCode.PRODUCTFL]: 'Does Not Promote/sell Frontline',
    [DataVendorCancelledReasonCode.PRODUCTOTH]: 'Does Not Promote/sell other BI products',
    [DataVendorCancelledReasonCode.PRODUCTBI]: 'Does Not Promote/sell any BI products',
    [DataVendorCancelledReasonCode.SOFTWARE]: 'Unsupported Software',
    [DataVendorCancelledReasonCode.PRIVACY]: 'Privacy Concerns',
    [DataVendorCancelledReasonCode.DATA]: 'Insufficient Data',
    [DataVendorCancelledReasonCode.PSDI]: 'PC/SW/DB/HSI Issue',
    [DataVendorCancelledReasonCode.O]: 'Other/Reason Not Given',
    [DataVendorCancelledReasonCode.EE]: 'Enrolled in Error',
    [DataVendorCancelledReasonCode.MAIL]: 'Clinic does not want to send direct mail',
    [DataVendorCancelledReasonCode.SHAREDB]: 'Clinic shares DB with other location',
    [DataVendorCancelledReasonCode.INTEREST]: 'Not Interested',
    [DataVendorCancelledReasonCode.CCP_ISSUE]: 'Program Issue Related',
    [DataVendorCancelledReasonCode.INACTIVE]: 'Inactive clinic account/location',
};
var DataVendorReferToRepReasonCode;
(function (DataVendorReferToRepReasonCode) {
    DataVendorReferToRepReasonCode["NOREACH"] = "NOREACH";
    DataVendorReferToRepReasonCode["REQUEST"] = "REQUEST";
})(DataVendorReferToRepReasonCode = exports.DataVendorReferToRepReasonCode || (exports.DataVendorReferToRepReasonCode = {}));
var DataVendorInProcessReasonCode;
(function (DataVendorInProcessReasonCode) {
    DataVendorInProcessReasonCode["CONTACT"] = "CONTACT";
    DataVendorInProcessReasonCode["DVWAITDATA"] = "DVWAITDATA";
    DataVendorInProcessReasonCode["DVRECV"] = "DVRECV";
    DataVendorInProcessReasonCode["DVPRCSS"] = "DVPRCSS";
    DataVendorInProcessReasonCode["DVREVW"] = "DVREVW";
})(DataVendorInProcessReasonCode = exports.DataVendorInProcessReasonCode || (exports.DataVendorInProcessReasonCode = {}));
exports.dataVendorInProcessReasonCodeToDescription = {
    [DataVendorInProcessReasonCode.CONTACT]: 'Clinic being contacted by DV for data',
    [DataVendorInProcessReasonCode.DVWAITDATA]: 'Clinic contacted, DV waiting on data',
    [DataVendorInProcessReasonCode.DVRECV]: 'Clinic data has been sent to DV',
    [DataVendorInProcessReasonCode.DVPRCSS]: 'Data in process at Data Vendor',
    [DataVendorInProcessReasonCode.DVREVW]: 'Further review of data needed by DV',
};
//# sourceMappingURL=ImportDataVendorEnrollmentJobInput.js.map